import { useItem } from './hooks/use-context';

export function OccurrenceDescription() {
  const { sections } = useItem();

  const questions = sections.flatMap((section) => section.questions);

  const getAnswer = (id: string, useContent = false) => {
    const q = questions.find((q) => q.question_id === id);
    if (!q || !q.answers || q.answers.length === 0) return '';
    return useContent ? q.answers[0].content : q.answers[0].option || q.answers[0].content;
  };

  const getQuestion = (id: string) => questions.find((q) => q.question_id === id);

  const description = getAnswer('6e7d7e0f-b548-4da1-baee-16f1e4aa5233', true); // Descrição da Ocorrência
  const galleryQuestion = getQuestion('9e690e85-b7e3-4254-a2df-f9d1b572b04f'); // Registro fotográfico
  const gatheredInfo = getAnswer('0c01e196-20e7-435a-ab98-b9dd07a3e6a1', true); // 1.1 Informações levantadas
  const depoimentos = getAnswer('13d2dbd0-9fbc-4276-9713-03218be67afd', true); // 1.2 Depoimentos
  const equipe = getAnswer('0dc72027-91f8-495f-b0e2-3f711538284d', true); // 1.3 Equipe de Investigação

  return (
    <div style={{ color: '#000', fontSize: '13px', lineHeight: '1.5', fontFamily: 'sans-serif' }}>
      <div style={{ backgroundColor: '#D9D9D9', padding: '4px', fontWeight: 'bold', marginBottom: '8px', fontSize: '14px' }}>
        1- DESCRIÇÃO DA OCORRÊNCIA:
      </div>
      <div style={{ marginBottom: '16px', minHeight: '60px' }}>
        {description}
      </div>

      <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
        Imagens do local do acidente:
      </div>
      <div style={{ border: '1px solid #000', padding: '10px', minHeight: '150px', marginBottom: '24px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {galleryQuestion?.answers?.map((answer) => (
          <img
            key={answer.id}
            src={answer.content || ''}
            alt="Registro Fotográfico"
            style={{ width: '200px', height: 'auto', objectFit: 'contain' }}
          />
        ))}
      </div>

      <div style={{ marginBottom: '16px' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
          1.1- Informações levantadas <span style={{ fontWeight: 'normal', fontSize: '11px', color: '#555' }}>(Dados obtidos, observados):</span>
        </div>
        <div style={{ minHeight: '40px' }}>{gatheredInfo}</div>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
          1.2- Depoimentos <span style={{ fontWeight: 'normal', fontSize: '11px', color: '#555' }}>(Informações relatadas após a ocorrência):</span>
        </div>
        <div style={{ minHeight: '40px' }}>{depoimentos}</div>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
          1.3- Equipe de Investigação:
        </div>
        <div style={{ minHeight: '40px' }}>{equipe}</div>
      </div>
    </div>
  );
}
